import React, { PropTypes } from 'react';
import Modal from "../Modal";
import { inject, observer } from "mobx-react";
import { autorun, observable } from "mobx";
import Form, { FormActions, FormBody, TextInput } from "../Form";
import { dataSource as api } from '../../actions/api';
import ReactDropzone from 'react-dropzone';

@inject('dataOriginParameterTemplateStore', 'parameterStore')
@observer
class DataSourceParameterTemplate extends React.Component {

  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  slug = '/daq/parameter-template';

  @observable parameterSearch = '';
  @observable parameterTemplate = {
    id: '',
    name: '',
    parameters: []
  };

  componentWillMount() {
    const { dataOriginParameterTemplateStore, parameterStore, params: { id } } = this.props;
    if (!parameterStore.isLoading && !parameterStore.items.length) parameterStore.fetchItems();

    this.dispose = autorun(() => {
      let template = dataOriginParameterTemplateStore.findById(id);
      if ((!!template || id === 'add') && !!parameterStore.items.length && !this.parameterTemplate.length) {
        this.parameterTemplate.name = template && template.name;
        this.parameterTemplate.parameters = parameterStore.items.map(item => {
          let parameter = template && template.parameters && template.parameters.find(i => +i.parameter_id === +item.id);
          return ({
            parameter_id: item.id,
            parameter_name: item.name,
            selected: !!parameter,
            code: !!parameter ? parameter.code : item.code,
            original_code: item.code
          })
        });
      }
    })
  }

  onSave = e => {
    e.preventDefault();
    const { notify, router } = this.context;
    const { dataOriginParameterTemplateStore, params: { id } } = this.props;
    let payload = {
      name: this.parameterTemplate.name,
      parameters: this.parameterTemplate.parameters.reduce((acc, item) => {
        if (!!item.selected) {
          acc.push({
            parameter_id: item.parameter_id,
            code: item.code
          })
        }
        return acc;
      }, [])
    };
    (id === 'add' ? dataOriginParameterTemplateStore.createItem(payload) : dataOriginParameterTemplateStore.updateItem(Object.assign(payload, { id }))).then(res => {
      notify.success(res);
      router.push(this.slug);
    }).catch(err => {
      notify.error(err);
    });
  };

  containsCharacter = (s1 = '', s2 = '') => s1.toString().toLowerCase().indexOf(s2.toString().toLowerCase()) > -1;


  onUpload = (files) => {
    const { notify } = this.context;
    const { parameterStore } = this.props;

    let reader = new FileReader();
    reader.readAsText(files[0]);
    reader.onabort = console.log;
    reader.onload = () => {
      try {
        let payload = JSON.parse(reader.result);
        this.parameterTemplate.name = payload.name;
        this.parameterTemplate.parameters = parameterStore.items.map(item => {
          let parameter = payload.parameters && payload.parameters.find(i => item.code === i.original_code);
          return ({
            parameter_id: item.id,
            parameter_name: item.name,
            selected: !!parameter,
            code: !!parameter ? parameter.code : item.code,
            original_code: item.code
          })
        });
      } catch (e) {
        console.log(e)
        notify.error({ message: 'Invalid File.' })
      }
    }
  }

  onDownload = (e) => {
    e.preventDefault();
    let payload = {
      name: this.parameterTemplate.name,
      parameters: this.parameterTemplate.parameters.reduce((acc, item) => {
        if (!!item.selected) {
          acc.push({
            code: item.code,
            original_code: item.original_code
          })
        }
        return acc;
      }, [])
    };
    let hiddenElement = document.createElement('a');
    document.body.appendChild(hiddenElement);
    hiddenElement.href = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(payload));
    hiddenElement.target = '_blank';
    hiddenElement.download = `${payload.name}-${Date.now()}.json`;
    hiddenElement.click();
  };

  _renderTable = ({ caption, id, data, editableCode }) => {
    return (
      <div style={{ width: '45%', minWidth: '400px', height: '60vh', overflowY: 'auto' }}>
        <table className='DataTable'>
          <thead>
            <tr>
              <th colSpan={2} style={{ position: 'sticky', top: 0, zIndex: 100000, background: 'white', color: 'black', textAlign: 'center' }}>{caption}</th>
            </tr>
            <tr>
              <th style={{ position: 'sticky', top: 28, zIndex: 100000, background: '#3c8dbc' }}>{caption === 'Available Paramaters' ? 'Parameter Code' : 'Origin Parameter Code'}</th>
              <th style={{ position: 'sticky', top: 28, zIndex: 100000, background: '#3c8dbc' }}>Parameter</th>
            </tr>
          </thead>
          <tbody>{data.map(item => (
            <tr key={`data-source-${id}-parameter-template-paramter-${item.parameter_id}-available`} onClick={() => item.selected = !item.selected} style={{ cursor: 'pointer' }}>
              <td style={{ minWidth: '150px' }}>{editableCode ? <input type='text' value={item.code} onClick={e => e.stopPropagation()} onChange={e => item.code = e.target.value} /> : item.code}</td>
              <td>{item.parameter_name}</td>
            </tr>
          ))}</tbody>
        </table>
      </div>
    )
  };

  render() {
    const { dataOriginParameterTemplateStore, params: { id } } = this.props;
    if (dataOriginParameterTemplateStore.isLoading) return <div />;

    let availableParameters = this.parameterTemplate.parameters.filter(item => !item.selected && (this.containsCharacter(item.parameter_name, this.parameterSearch) || this.containsCharacter(item.code, this.parameterSearch)));
    let selectedParameters = this.parameterTemplate.parameters.filter(item => !!item.selected && (this.containsCharacter(item.parameter_name, this.parameterSearch) || this.containsCharacter(item.code, this.parameterSearch)));
    return (
      <Modal slug={this.slug} title={`Edit Parameter Template`} handleSave={this.onSave}>
        <div>
          <Form>
            <FormBody>
              <TextInput label={'Name'} value={this.parameterTemplate.name} onChange={e => this.parameterTemplate.name = e.target.value} />
              <TextInput label={'Filter Parameter'} value={this.parameterSearch} onChange={e => this.parameterSearch = e.target.value} />
              <div className='inline-grid space-evenly full-width overflow-x-scroll'>
                {this._renderTable({ caption: 'Available Paramaters', id, data: availableParameters })}
                {this._renderTable({ caption: 'Selected Paramaters', id, data: selectedParameters, editableCode: true })}
              </div>
            </FormBody>
            <FormActions>
              <button onClick={this.onSave}>Save</button>
              {id === 'add' ?
                <button onClick={e => { e.preventDefault(); this.refs.dropzone.open(); }}>Upload</button> :
                <button onClick={this.onDownload}>Download</button>}
            </FormActions>
          </Form>
          <ReactDropzone ref="dropzone" onDrop={this.onUpload} style={{ display: 'none' }} />
        </div>
      </Modal>
    );
  }
}

export default DataSourceParameterTemplate;


// WEBPACK FOOTER //
// ./src/components/DataSource/DataOriginParameterTemplateView.js